import useModal from "@/lib/hooks/useModal";
export const menuModalName = "mobile-menu";
export default function useFilterModal() {
  const { isOpen, openModal, closeModal, toggleModal } = useModal(
    menuModalName,
    () => {}
  );

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal
  };
}
